import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Jobs from "../components/Jobs";

const JobsPage = () => {
  const { t, lang } = useLanguage();
  const navigate = useNavigate();
  useReveal([lang]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const applyToJob = (jobTitle) => {
    // Persist intent so the home contact form can prefill across routes
    sessionStorage.setItem(
      "pss_apply",
      JSON.stringify({ role: "worker", subject: jobTitle })
    );
    navigate("/");
  };

  return (
    <div className="App min-h-screen">
      <Header />
      <main className="container-px mx-auto max-w-7xl pt-32 pb-24">
        <div className="reveal text-center">
          <p className="text-xs font-semibold tracking-[0.3em] text-white/50">{t.jobs.eyebrow}</p>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white">
            {t.jobs.title}
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/60">{t.jobs.subtitle}</p>
        </div>

        <div className="mt-14">
          <Jobs onApply={applyToJob} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default JobsPage;
